import { createSelector } from 'reselect';

/**
 * Selector for standard crews based on current filtering criteria.
 * Limits displayed standard crews to delivery or installation crews
 * depending on what is currently visible.
 *
 * Note that other standard crews may be displayed if jobs/deliveries they
 * are assigned to are visible (this happens later in eventsByCrew.js).
 */
export const equipmentSelector = createSelector(
  (state) => state.equipment,
  
  (equipment) => {
    return equipment;  // Ne selector now but need to confirm if any selction criteria is required
  }
);
